import { ThemeProvider } from "@emotion/react";
import {
    Box,
    Typography,
    FormControl,
    FormHelperText,
    TextField,
    TextareaAutosize,
} from "@mui/material";
import { LightTheme } from "@refinedev/mui";
import { MessageFormProps } from "interfaces/common";
import CustomButton from "./CustomButton";

const MessageForm = ({
    type,
    register,
    handleSubmit,
    formLoading,
    onFinishHandler,

}: MessageFormProps) => {
    return (
        <Box>
            <Typography fontSize={25} fontWeight={700} color="#fcfcfc">
                {type} a Message
            </Typography>

            <Box mt={2.5} borderRadius="20px" padding="20px" bgcolor="#fcfcfc">
                <form
                    style={{
                        marginTop: "20px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                   
                    }}
                    onSubmit={handleSubmit(onFinishHandler)}
                >
                    <FormControl>
                        <FormHelperText
                            sx={{
                                fontWeight: 500,
                                margin: "10px 0",
                                fontSize: 16,
                                color: "black",
                            }}
                        >
                            Subject
                        </FormHelperText>
                        <ThemeProvider theme={LightTheme}>
                        <TextField
                            fullWidth
                            required
                            id="outlined-basic"
                            color="info"
                            variant="outlined"
                            
                            {...register("title", { required: true })}
                        />
                        </ThemeProvider>
                    </FormControl>
                    <FormControl>
                        <FormHelperText
                            sx={{
                                fontWeight: 500,
                                margin: "10px 0",
                                fontSize: 16,
                                color: "#11142d",
                            }}
                        >
                            Message
                        </FormHelperText>
                        <TextareaAutosize
                            minRows={5}
                            required
                            placeholder="Enter message"
                            color="info"
                            style={{
                                width: "100%",
                                background: "transparent",
                                fontSize: "16px",
                                borderColor: "rgba(0,0,0,0.23)",
                                borderRadius: 6,
                                padding: 10,
                                color: "black",
                            }}
                            {...register("message", { required: true })}
                        />
                    </FormControl>
                   

                    <CustomButton
                        type="submit"
                        title={formLoading ? "Submitting..." : "Submit"}
                        backgroundColor="#475be8"
                        color="#fcfcfc"
                    />
                </form>
            </Box>
        </Box>
    );
};

export default MessageForm;